import { render, staticRenderFns } from "./Logged.vue?vue&type=template&id=2985fa0d&scoped=true&"
import script from "./Logged.vue?vue&type=script&lang=js&"
export * from "./Logged.vue?vue&type=script&lang=js&"
import style0 from "./Logged.vue?vue&type=style&index=0&id=2985fa0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985fa0d",
  null
  
)

export default component.exports